'use client'

import type { SwitcherItemProps } from '@maestro/commerce-blocks/components/switcher/switcher.types'

import classNames from 'classnames'
import { useTranslations } from 'next-intl'

import { Button } from '@pearlconvert/ui/components/button'

export default function SwitcherItem(props: SwitcherItemProps) {
  const {
    name,
    description,
    isSelected,
    isPending,
    isDisabled,
    onSelect,
    className,
  } = props
  const t = useTranslations('commerce-blocks.switcher.item')

  return (
    <li
      className={classNames(
        'switcher__item',
        { 'switcher__item--selected': isSelected },
        className
      )}
    >
      <div className="switcher__item-info">
        <span className="switcher__item-name">{name}</span>
        {description && (
          <span className="switcher__item-description">{description}</span>
        )}
      </div>
      <div className="switcher__item-action">
        <Button
          className="switcher__item-select"
          ariaLabel={t('select-aria-label', { name })}
          type="primary"
          size="small"
          disabled={isSelected || isPending || isDisabled}
          isLoading={isPending}
          onClick={onSelect}
        >
          {isSelected ? t('selected') : t('select')}
        </Button>
      </div>
    </li>
  )
}
